import { DETAIL_IMAGE_RATIO_OPTIONS, SCREEN_GAP_OPTIONS } from './options.js';
export const PRODUCT_SECTION_ITEMS = [
    { value: 'description', label: '상품 설명·배송비·반품 안내' },
    { value: 'sameDealer', label: '판매자의 다른 상품' },
];
export const PRODUCT_SCREEN_FIELDS = [
    {
        key: 'product.detailImage.aspectRatio',
        group: '상품 이미지',
        label: '상품 이미지 비율',
        help: '마켓 상품 상세 화면 맨 위 상품 사진(넘겨 보는 이미지)의 가로:세로 비율. 가로는 화면 폭에 맞춘다',
        type: 'enum',
        defaultValue: '1:1',
        options: DETAIL_IMAGE_RATIO_OPTIONS,
    },
    {
        key: 'product.sections.order',
        group: '구역',
        label: '구역 순서',
        help: '상품 사진·이름·가격·판매자 구역 아래에 놓는 구역의 순서',
        type: 'order',
        defaultValue: PRODUCT_SECTION_ITEMS.map((item) => item.value),
        items: PRODUCT_SECTION_ITEMS,
    },
    {
        key: 'product.sameDealer.visible',
        group: '구역',
        label: '판매자의 다른 상품 노출',
        help: '끄면 상품 상세 화면에서 "판매자의 다른 상품" 구역(가로 상품 목록·상점 보기)을 그리지 않는다',
        type: 'boolean',
        defaultValue: true,
    },
    {
        key: 'product.sections.gap',
        group: '구역',
        label: '구역 사이 간격',
        help: '상품 상세 화면 구역(상품 정보·상품 설명·판매자의 다른 상품) 사이의 간격 — 간격만큼 뒤 배경색이 보인다',
        type: 'enum',
        defaultValue: 'default',
        options: SCREEN_GAP_OPTIONS,
    },
];
//# sourceMappingURL=product.js.map